import router from 'next/router';
import { Translate, useTranslate } from '~/i18n';
import { formatNumber } from '~/utils/format-price';

const PayoutBreakdownNumbers = ({ data }: any) => {
   const { lang } = useTranslate();
   return (
      <div className="flex flex-col justify-center mx-4">
         <div className="border-b border-dashed flex items-center">
            <img className="my-3" src={`/images/dashboard/paid.svg`} />
            <div className="flex flex-col mx-3">
               <span className="text-[#B5B5C3] text-xs">
                  <Translate id="payout:paid" />
               </span>
               <span className="text-sm font-bold">{formatNumber(data?.paid)} SR</span>
            </div>
         </div>
         <div className="border-b border-dashed flex items-center">
            <img className="my-3" src={`/images/dashboard/payout_requested.svg`} />
            <div className="flex flex-col mx-3">
               <span className="text-[#B5B5C3] text-xs">
                  <Translate id="payout:payout requests" />
               </span>
               <span className="text-sm font-bold">{formatNumber(data?.payout_requested)} SR</span>
            </div>
         </div>
         <div className="border-b border-dashed flex items-center">
            <img className="my-3" src={`/images/dashboard/ready_for_payout.svg`} />
            <div className="flex flex-col mx-3">
               <span className="text-[#B5B5C3] text-xs">
                  <Translate id="payout:ready for payout" />
               </span>
               <span className="text-sm font-bold">{formatNumber(data?.ready_for_payout)} SR</span>
            </div>
            <div className="ml-auto">
               <button
                  onClick={() => router.push(`/${lang}/profile/business/payout`)}
                  disabled={!data?.show_create_claim_button}
                  className="bg-primary disabled:bg-gray-500 disabled:cursor-not-allowed text-xs text-white  px-4 py-1 rounded-md ">
                  <Translate id="payout:request" />
               </button>
            </div>
         </div>
      </div>
   );
};

export default PayoutBreakdownNumbers;
